<script lang="ts" setup>
import { IconChevronLeft, IconChevronRight } from '@hobbii/hobbii-ui';
import { lock, unlock } from 'tua-body-scroll-lock';
import { onBeforeUnmount, onMounted, ref } from 'vue';

import Image from '@/shared/components/UI/Image.vue';

defineProps<{
  prevImage: string | null;
  nextImage: string | null;
  totalNumberOfPosts: number | undefined;
  activeGalleryIndex: number;
}>();

const emit = defineEmits<{
  (e: 'prev-gallery'): void;
  (e: 'next-gallery'): void;
}>();

const root = ref<HTMLElement | null>(null);

onMounted(() => {
  lock(root.value);
});
onBeforeUnmount(() => {
  unlock(root.value);
});
</script>
<template>
  <div class="fixed inset-y-0 left-0 grid w-full grid-rows-[1fr_auto] flex-col">
    <div ref="root" class="size-full max-h-full overflow-y-scroll bg-white">
      <slot />
    </div>
    <div
      class="grid w-full grid-cols-3 items-center border-t bg-white p-4 shadow-[0_-5px_5px_rgba(0,0,0,0.05)]"
    >
      <button
        v-if="prevImage"
        class="inline-flex items-center gap-1"
        @click="emit('prev-gallery')"
      >
        <IconChevronLeft class="text-xl text-primary" />
        <figure class="size-10 rounded-full bg-primary-100 ring-2 ring-primary">
          <Image
            :src="prevImage"
            :width="48"
            :height="48"
            theme="dark"
            loader="fade"
            img-classes="aspect-square size-10 h-full shrink-0 rounded-full bg-gray-600 object-cover"
            alt="Prev gallery"
          />
        </figure>
      </button>
      <span v-else><!-- alternate empty element instead of button --></span>

      <div class="text-center text-sm text-gray-500">
        <template v-if="totalNumberOfPosts">
          {{ activeGalleryIndex + 1 }} / {{ totalNumberOfPosts }}
        </template>
      </div>

      <button
        v-if="nextImage"
        class="inline-flex items-center gap-1 justify-self-end"
        @click="emit('next-gallery')"
      >
        <figure class="size-10 rounded-full bg-primary-100 ring-2 ring-primary">
          <Image
            :src="nextImage"
            :width="48"
            :height="48"
            theme="light"
            loader="fade"
            img-classes="aspect-square size-10 h-full shrink-0 rounded-full bg-gray-600 object-cover "
            alt="Next gallery"
          />
        </figure>
        <IconChevronRight class="text-xl text-primary" />
      </button>
      <span v-else><!-- alternate empty element instead of button --></span>
    </div>
  </div>
</template>
